var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("receivablePayable.exportOrdersByDate"),
        visible: _vm.visible,
        width: "500px",
        "before-close": _vm.close,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            size: "small",
            rules: _vm.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "date" } },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("operationCenter.PleaseSelect"),
                      },
                      model: {
                        value: _vm.form.timeField,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "timeField", $$v)
                        },
                        expression: "form.timeField",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basicData.BusinessTime"),
                          value: "operate_time",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("newOrder.clientExitTime"),
                          value: "customer_send_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "-",
                  "start-placeholder": _vm.$t("operationCenter.startDate"),
                  "end-placeholder": _vm.$t("operationCenter.endDate"),
                  "default-time": ["00:00:00", "23:59:59"],
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.form.date,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "date", $$v)
                  },
                  expression: "form.date",
                },
              }),
            ],
            2
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("basicData.CustomerName"),
                prop: "customerId",
              },
            },
            [
              _c("QueryCustomerCmp", {
                attrs: { val: _vm.form.customerId },
                on: {
                  change: function (val) {
                    return (_vm.form.customerId = val)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("collectionCenter.businessT"),
                prop: "businessType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("operationCenter.PleaseSelect"),
                    clearable: "",
                  },
                  on: { change: _vm.changeType },
                  model: {
                    value: _vm.form.businessType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "businessType", $$v)
                    },
                    expression: "form.businessType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("collectionCenter.lanshou"),
                      value: 1,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("collectionCenter.expressDelivery"),
                      value: 0,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.businessType === 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("newOrder.CollectionType"),
                    prop: "collectionCategory",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("operationCenter.PleaseSelect"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.collectionCategory,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "collectionCategory", $$v)
                        },
                        expression: "form.collectionCategory",
                      },
                    },
                    _vm._l(_vm.COLLECTION_CATEGORY_TYPE, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.form.businessType === 0
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("placeOrder.cargoType"),
                    prop: "cargoType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("operationCenter.PleaseSelect"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.cargoType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cargoType", $$v)
                        },
                        expression: "form.cargoType",
                      },
                    },
                    _vm._l(_vm.CARGO_TYPE, function (item, ind) {
                      return _c("el-option", {
                        key: ind,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-alert", {
            attrs: {
              title: _vm.$t("receivablePayable.exportLimit"),
              type: "warning",
              "show-icon": "",
              closable: false,
            },
          }),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.close } },
            [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }